import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Option from '../Option';
import Search from '../Search';
import styles from './styles.module.scss';

const OptionsList = ({
                       options,
                       selectOption,
                       selected,
}) => {
  const [filter, setFilter] = useState('');
  const filteredOptions = options.filter(option => option.label.toLowerCase().includes(filter.toLowerCase()));

  return (
    <>
      <Search onChange={setFilter}/>
      <div className={styles.optionList}>
        {
          filteredOptions.map((option, ind) => (
            <Option
              key={ind}
              value={option}
              isSelected={option.value === selected.value}
              selectOption={selectOption}
            >
              {option.label}
            </Option>
          ))
        }
      </div>

    </>
  )
};

OptionsList.propTypes = {
  options: PropTypes.array,
  selectOption: PropTypes.func.isRequired,
  selected: PropTypes.object
};

export default OptionsList;
